module.exports = __webpack_public_path__ + "static/media/luke-chesser.aec6ab83.jpg";